// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-RNJu","importantInfo":"styles_importantInfo__3Sz-O"};